var exports = {
  "zr": "x31de4314--d6bc34--root",
  "ZX": "x31de4314--d6bc34--amenities-list",
  "mU": "x31de4314--d6bc34--amenity-item",
  "ur": "x31de4314--d6bc34--link-to-details",
};

module.exports = exports;
